import { getDuprApi } from '@/app/commons/network/duprApiCore'
import { MainContent } from '@/components/content'
import { MainLayout } from '@/components/layouts'
import { Loading } from '@/components/loading'
import { MatchItem } from '@/components/match/Match'
import { MainSidebar, MobileSidebar } from '@/components/sidebar'
import { Match } from '@/types'
import { useQuery } from '@tanstack/react-query'
import { useLocation } from 'react-router-dom'

export function MatchDisplay({ id }: { id: number }) {
  const duprApi = getDuprApi()

  const { data, isLoading } = useQuery({
    queryKey: ['match', id],
    queryFn: async () => {
      return await duprApi.matches.matchDetails(id)
    },
  })

  const match = data?.data.result as Match

  return isLoading ? (
    <Loading />
  ) : match !== undefined ? (
    <MatchItem match={match} playerId={0} />
  ) : (
    <h1 className="text-white">Match Not found</h1>
  )
}

export function MatchPage() {
  const location = useLocation()
  const id = Number(location.pathname.split('/').pop())

  return (
    <>
      <MobileSidebar />
      <MainLayout>
        <MainSidebar />
        <MainContent>{id && <MatchDisplay id={id} />}</MainContent>
      </MainLayout>
    </>
  )
}
